import { render, staticRenderFns } from "./MessageImageBlock.vue?vue&type=template&id=3c448dc5&scoped=true&"
import script from "./MessageImageBlock.vue?vue&type=script&lang=js&"
export * from "./MessageImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./MessageImageBlock.vue?vue&type=style&index=0&id=3c448dc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c448dc5",
  null
  
)

export default component.exports